import { styled } from '@mui/system';

const CustomTabPanel = styled('div')({
  padding: '0',
  width: '100%',
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <CustomTabPanel
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </CustomTabPanel>
  );
}

export default TabPanel;
